import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { takeWhile } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';

import { select, Store } from '@ngrx/store';

import * as fromStore from '../store';
import * as fromAuthStore from '../../../core/store';
import { SchoolDetails } from '../models';

@Component({
    selector: 'opus-school-page',
    templateUrl: './school-details.component.html',
})
export class SchoolDetailsComponent implements OnInit, AfterViewInit {
    private subscription?: Subscription;
    alive = true;
    schoolType: number;
    schoolName: string;
    adminRole: string;
    schoolDetails$: Observable<SchoolDetails>;
    school: SchoolDetails;
    panels$: Observable<{ [id: string]: fromStore.PanelState }>;
    scrollTo: Element = null;
    navigatingToPreferences = false;
    @Input() canEdit;


    constructor(private store: Store<fromStore.SchoolsState>, private router: Router, private route: ActivatedRoute) {
        router.events.subscribe(s => {
            if (s instanceof NavigationEnd) {
                const tree = router.parseUrl(router.url);

                if (tree.fragment) {
                    const element = document.querySelector('#' + tree.fragment);

                    if (element) {
                        this.scrollTo = element;
                        element.scrollIntoView();
                    }
                }
            }
        });
    }

    ngOnInit() {
        this.schoolDetails$ = this.store.pipe(select(fromStore.getSchoolDetailsEntity));
        this.panels$ = this.store.pipe(select(fromStore.getDetailsStatePanels));
        this.schoolDetails$.pipe(
            takeWhile(() => this.alive)
        ).subscribe(s => {
            this.school = s;
            this.schoolType = s.type;
            this.schoolName = s.longName;

            const types = [5, 8];
            this.adminRole = 'aa_OPUS-MAA_LimitedEntityAdmin';

            this.canEdit = true;
            if (types.includes(this.schoolType) && (this.schoolName.includes("ADULT") || this.schoolName.includes("HOME SCHOOL"))) {
                this.canEdit = false;
                this.subscription = this.store.pipe(select(fromAuthStore.getUserAuthInfo)).subscribe(x => {
                    if (x) {
                        const rolesAllowed = new Set<string>(['aa_OPUS-MAA_Admin', 'aa_OPUS-MAA_EntityAdmin']);
                        const matches = [...rolesAllowed].filter((element) => x.roleNames.has(element));
                        if (matches.length > 0) this.canEdit = true;
                    }
                });

                this.adminRole = 'aa_OPUS-MAA_Admin';
            }

        });
    }

    ngOnDestroy() {
        console.log('SchoolDetailsComponent.ngOnDestroy()...');
        this.alive = false;
    }

    ngAfterViewInit() {
        if (this.scrollTo) {
            console.log('scrollIntoView: ', this.scrollTo);

            this.scrollTo.scrollIntoView();
            this.scrollTo = null;
        }
    }

    navigateToPreferences() {
        this.navigatingToPreferences = true;

        setTimeout(() => {
            this.router.navigate(['./', 'preferences'], { relativeTo: this.route });
        }, 100);
    }

    onToggleEditor(key: string, open: boolean) {
        this.store.dispatch(new fromStore.UpdateEditorState({ key, open }));
    }
}
